import {withDispatchActions} from "../../../../shared/hoc/withDispatchActions";
import AddNote from "../../../pages/notes/add-note";
import {toggleFenceEditModeActions} from "../FencesContainer.helpers";

const AddNoteWithToggleActions = withDispatchActions(AddNote, toggleFenceEditModeActions);

export default AddNoteWithToggleActions;